import React from 'react'
import PropTypes from 'prop-types';

import Head from 'next/head';
import { useRouter } from 'next/router';


import { getUrlFromRoute } from '@app/helpers';

function extractLocationData(location, opportunityUrl) {
  if (location) {
    return {
      "@type": "Place",
      "name": location.name,
      "address": location.formatted_address
    }
  }
  return {
    "@type": "VirtualLocation",
    "url": opportunityUrl
  }
}

function extractPaymentData(paymentInfo, offerUrl, createDate) {
  const initalData = {
    "@type": "Offer",
    "url": offerUrl,
    "availability": "https://schema.org/InStock",
    "validFrom": createDate
  }
  if (paymentInfo) {
    return paymentInfo.map(
      ({cost, currency}) => ({
        ...initalData,
        "price": cost,
        "priceCurrency": currency.toUpperCase(),
      })
    )
  }
  return {
    ...initalData,
    "price": "0",
    "priceCurrency": "USD",
  }
}

function OpportunityJsonLd({
  title, 
  description,
  url,
  location,
  images,
  offerUrl,
  organisation,
  startDate,
  endDate,
  createDate,
  paymentInfo
}) {
  const router = useRouter();

  const organisationUrl = getUrlFromRoute('organisation_view', { 
    params: { 
      slug: organisation.slug
    },
    locale: router.locale
  });

  const jsonData= {
    "@context": "https://schema.org",
    "@type": "MusicEvent",
    "location": extractLocationData(location, url),
    "name": title,
    "description": description,
    "image": images,
    "url": url,
    "offers": extractPaymentData(paymentInfo, offerUrl, createDate),
    "eventAttendanceMode": `https://schema.org/${location ? 'Offline': 'Online' }EventAttendanceMode`,
    "eventStatus": "https://schema.org/EventScheduled",
    "organizer": {
      "@type": "Organization",
      "name": organisation.name,
      "url": organisationUrl
    }
  };

  if (startDate) {
    jsonData.startDate = startDate;
  }

  if (endDate) {
    jsonData.endDate = endDate;
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonData)}}
        key="jsonld-event"
      />
    </Head>
  );
}

OpportunityJsonLd.propTypes = {
  title: PropTypes.string.isRequired, 
  description: PropTypes.string.isRequired,
  createDate: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  url: PropTypes.string.isRequired,
  location: PropTypes.shape({
    name: PropTypes.string.isRequired,
    formatted_address: PropTypes.string.isRequired
  }),
  paymentInfo: PropTypes.arrayOf(
    PropTypes.shape({
      cost: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired
    })
  ),
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  offerUrl: PropTypes.string.isRequired,
  organisation: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired
  }).isRequired
};

OpportunityJsonLd.defaultProps = {
  location: null,
  endDate: null,
  paymentInfo: null
};

export default OpportunityJsonLd;
